/* global Bugsnag */
import { Component } from "react"
import Icon from "components/planning_center_icon"
import { Menu, MenuButton, MenuList, MenuItem } from "@reach/menu-button"

class AdminPaymentShow extends Component {
  constructor(props) {
    super(props)

    this.sendReceipt = this.sendReceipt.bind(this)

    this.state = {
      errors: []
    }
  }

  render() {
    const { notificationOptions } = this.props

    return (
      <Menu>
        <MenuButton className="btn-outline sm ml-1 f-1 f-0@sm">
          Resend receipt
          <span data-reach-menu-button-toggle-icon="true">
            <Icon symbol="general#down-caret" />
          </span>
        </MenuButton>
        <MenuList>
          {notificationOptions.map(person => (
            <MenuItem onSelect={() => this.sendReceipt(person.id)} key={person.id}>
              {person.first_name + " " + person.last_name}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    )
  }

  sendReceipt(personId) {
    const { payment } = this.props
    fetch(`/payments/${payment.id}/send_receipt?payment[person_ids_to_notify]=${personId}`, {
      method: "GET",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
        "X-CSRF-Token": $.rails.csrfToken()
      }
    })
      .then(resp => {
        if (resp.errors) {
          this.setState({ errors: resp.errors })
        } else {
          Turbolinks.visit()
        }
      })
      .catch(resp => Bugsnag.notifyException(resp, "ResendPaymentReceiptError"))
  }
}

export default AdminPaymentShow
